import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _PROPS_BY_TRANSITION, _TRANSITIONS_BY_ANIMA, _TRANSITION_TYPE_TO_P;
export var BLUR_IN_TRANSITION = 'blurIn';
export var BLUR_OUT_TRANSITION = 'blurOut';
export var HEIGHT_TRANSITION = 'height';
export var ZOOM_ANIMATION = 'zoom';
export var ZOOM_TRANSITION = 'zoom';
export var BLUR_ANIMATION = 'blur';
export var SLIDE = 'slide';
export var FADE = 'fade';
export var DEFAULT_ANIMATION_DURATION = 250; // ms
export var DEFAULT_ANIMATION_DELAY = 25; // ms
export var DEFAULT_ZOOM_OUT_ANIMATION_DURATION = 4000; // ms

export var DEFAULT_BLUR_ANIMATION_PROPS = {
  opacity: 0.5,
  blur: '2px'
};
export var DEFAULT_HEIGHT_ANIMATION_PROPS = {
  height: 'auto',
  overflow: 'hidden'
};
export var DEFAULT_ZOOM_ANIMATION_PROPS = {
  scale: 1
};
export var PROPS_BY_TRANSITION = (_PROPS_BY_TRANSITION = {}, _defineProperty(_PROPS_BY_TRANSITION, BLUR_OUT_TRANSITION, DEFAULT_BLUR_ANIMATION_PROPS), _defineProperty(_PROPS_BY_TRANSITION, BLUR_IN_TRANSITION, DEFAULT_BLUR_ANIMATION_PROPS), _defineProperty(_PROPS_BY_TRANSITION, HEIGHT_TRANSITION, DEFAULT_HEIGHT_ANIMATION_PROPS), _defineProperty(_PROPS_BY_TRANSITION, ZOOM_TRANSITION, DEFAULT_ZOOM_ANIMATION_PROPS), _PROPS_BY_TRANSITION);
export var ANIMATION_STATUS = {
  PRE_ANIMATING: 'preAnimating',
  ANIMATING: 'animating',
  NO_ANIMATION: 'noAnimation',
  SERVER_SIDE: 'serverSide'
};
export var TRANSITIONS_BY_ANIMATION = (_TRANSITIONS_BY_ANIMA = {}, _defineProperty(_TRANSITIONS_BY_ANIMA, BLUR_ANIMATION, [BLUR_OUT_TRANSITION, BLUR_IN_TRANSITION]), _defineProperty(_TRANSITIONS_BY_ANIMA, ZOOM_ANIMATION, [ZOOM_TRANSITION]), _TRANSITIONS_BY_ANIMA);
export var ON_REVEAL = 'onReveal';
export var ON_OPTIONS = [ON_REVEAL];
export var TRANSITION_TYPE_TO_PROPERTY_NAME = (_TRANSITION_TYPE_TO_P = {}, _defineProperty(_TRANSITION_TYPE_TO_P, BLUR_OUT_TRANSITION, 'filter'), _defineProperty(_TRANSITION_TYPE_TO_P, BLUR_IN_TRANSITION, 'filter'), _defineProperty(_TRANSITION_TYPE_TO_P, HEIGHT_TRANSITION, 'height'), _defineProperty(_TRANSITION_TYPE_TO_P, ZOOM_TRANSITION, 'transform'), _TRANSITION_TYPE_TO_P);
export var ANIMATE_ON_MOUNT = 'mount';
export var RUN_ALWAYS = 'RUN_ALWAYS';
export var RUN_ONCE_EVERY_VISIT = 'RUN_ONCE_EVERY_VISIT';